import { Status, StatusProps } from '@insight-health-ai/roseate/components';
import { Call, CallStatus as CallStatusType } from 'src/models';

const statusAppearanceMap: Record<
  CallStatusType['call_status_key'],
  StatusProps['appearance']
> = {
  ended: 'success',
  completed: 'success',
  failed: 'error',
  inprogress: 'warning',
  active: 'info',
};

type CallStatusProps = {
  status: Call['status'];
  statusProps?: StatusProps;
};

export const CallStatus = ({ status, statusProps }: CallStatusProps) => {
  return (
    <Status
      size="sm"
      {...statusProps}
      appearance={
        statusAppearanceMap[status?.call_status_key || ''] || 'neutral'
      }
      label={status?.call_status_name || 'N/A'}
      style={{
        textTransform: 'capitalize',
      }}
    />
  );
};
